import { createSlice } from '@reduxjs/toolkit';
import type {
  ApiErrorBody,
  PanelEventSurveyStateDto,
  PanelPostEventListDto,
} from '@icebreaker/shared';
import { createAsyncActions } from '@icebreaker/shared/store';

/**
 * KURUM DETAYI › ETKİNLİK SONRASI (belge ve anket Story 8, tasarım kare 11).
 *
 * Liste salt okunurdur. Tek yazma "Anketi kapat"tır; başarıdan sonra ve sonucu
 * bilinmeyen ya da 409 dönen denemeden sonra liste yeniden çekilir (invalidation
 * `panelOrgPostEvent/surveyDisable` → `panel/organizationPostEvent`). Kurum
 * değişince eski kurumun satırları atılır.
 */
export const fetchOrganizationPostEvent = createAsyncActions<
  { organizationId: string },
  PanelPostEventListDto
>('panelOrgPostEvent/listFetch');

export const disableEventSurvey = createAsyncActions<
  { organizationId: string; eventId: string; reason: string },
  PanelEventSurveyStateDto
>('panelOrgPostEvent/surveyDisable');

type Phase = 'idle' | 'loading' | 'succeeded' | 'failed';

export interface OrganizationPostEventState {
  organizationId: string | null;
  data: PanelPostEventListDto | null;
  phase: Phase;
  error: ApiErrorBody | null;
  disable: {
    eventId: string | null;
    phase: Phase;
    error: ApiErrorBody | null;
  };
}

const initialState: OrganizationPostEventState = {
  organizationId: null,
  data: null,
  phase: 'idle',
  error: null,
  disable: { eventId: null, phase: 'idle', error: null },
};

const slice = createSlice({
  name: 'panelOrgPostEvent',
  initialState,
  reducers: {
    surveyDisableReset(state) {
      state.disable = { eventId: null, phase: 'idle', error: null };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrganizationPostEvent.request, (state, action) => {
        if (state.organizationId !== action.payload.organizationId) state.data = null;
        state.organizationId = action.payload.organizationId;
        state.phase = 'loading';
        state.error = null;
      })
      .addCase(fetchOrganizationPostEvent.success, (state, action) => {
        state.phase = 'succeeded';
        state.data = { ...action.payload, items: action.payload.items.map((row) => ({ ...row })) };
      })
      .addCase(fetchOrganizationPostEvent.failure, (state, action) => {
        state.phase = 'failed';
        state.error = action.payload;
      })
      .addCase(disableEventSurvey.request, (state, action) => {
        state.disable = { eventId: action.payload.eventId, phase: 'loading', error: null };
      })
      .addCase(disableEventSurvey.success, (state) => {
        state.disable.phase = 'succeeded';
      })
      .addCase(disableEventSurvey.failure, (state, action) => {
        state.disable.phase = 'failed';
        state.disable.error = action.payload;
      });
  },
});

export const { surveyDisableReset } = slice.actions;
export const organizationPostEventReducer = slice.reducer;
